module.exports = __webpack_public_path__ + "img/INE_default.71256dd5.png";